import { gql } from "graphql-tag"

const vendorsQuery = gql`
  type Query {
    getCountryById(id: ID!): Country
    getCountries(query: GetQueryCountries): [Country!]!
    getCountriesWave(query: GetWaveQueryCountries): CountriesWave!

    getLabelById(id: ID!): Label
    getLabels(query: GetQueryLabels): [Label!]!
    getLabelsWave(query: GetWaveQueryLabels): LabelsWave!

    getStoreById(id: ID!): Store
    getStores(query: GetQueryStores): [Store!]!
    getStoresWave(query: GetWaveQueryStores): StoresWave!

    getStoreLinkById(id: ID!): StoreLink
    getStoreLinks(query: GetQueryStoreLinks): [StoreLink!]!

    getVendorById(id: ID!): Vendor
    getVendors(query: GetQueryVendors): [Vendor!]!
    getVendorsWave(query: GetWaveQueryVendors): VendorsWave!

    searchLabels(searchLabelsInput: SearchLabelsInput!): [Label]
    searchLabelsByUrl(searchLabelsByUrlInput: SearchLabelsByUrlInput!): [Label]
    searchStores(searchStoresInput: SearchStoresInput!): [Store]
    searchVendors(searchVendorsInput: SearchVendorsInput!): [Vendor]
  }
`

export default vendorsQuery
